import { SkillConfigItemLoose } from '../../entities/skill-dataset';

export enum TerraformingSkillId {
  GrassBurst = 'grassBurst',
  FlowerWave = 'flowerWave'
}

export interface ITerraformingSkillConfigItem extends SkillConfigItemLoose {
  description: string;
}

export type TerraformingSkillsConfig = Record<TerraformingSkillId, ITerraformingSkillConfigItem>;
